import React from 'react';
import { connect } from 'react-redux'
import { BrowserView, MobileView, isMobile } from 'react-device-detect';
import { Row, Col, Divider, Popover, Button, Radio, Space, Input, Tooltip, Breadcrumb, BackTop } from 'antd';
import { PageHeader } from 'components/header';
import { InfoCircleOutlined, SearchOutlined, FilterOutlined, SortAscendingOutlined, DoubleRightOutlined, DownloadOutlined } from '@ant-design/icons';

import { isAuth, _setAxios, getParamTable, getParamTempTableFiltering, _scrollFloatBtn } from '../../../../lib/Helper';

import AuthRedirect from '../../../../components/AuthRedirect'
import Filter from '../modal/Filter';
import Export from '../modal/Export';
import Verification from '../modal/Verification';
// import Delete from '../modal/Delete';
// import Restore from '../modal/Restore';
import PreviewKTA from '../modal/PreviewKTA';
import Desktop from './Desktop';
import Mobile from './Mobile';
import SendWA from '../modal/SendWa';
import GenerateQrCode from '../modal/GenerateQrCode';


const tableOptions = {
  sorts: [{
    value: "ASC",
    label: "Ascending",
  }, {
    value: "DESC",
    label: "Descending",
  }],
  fields: [{
    value: "id",
    label: "Tanggal Pembuatan",
  }, {
    value: "nama",
    label: "Nama",
  }]
}

class SiswaIndex extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      values: {},
      table: {
        loading_first: false,
        loading: false,
        data: [],
        search: "",
        pagination: {
          current: 1,
          pageSize: 10,
          total: null,
        },
        sorting: [],
        filtering: {
          tahun_lulus: null,
          kategori: null,
        },
      },
      filter: {
        values: {
          tahun_lulus: null,
          kategori: null,
        },
        visible: false,
      },
      export: {
        values: {},
        visible: false,
      },
      verification: {
        data: {},
        visible: false
      },
      previewKTA: {
        data: {},
        visible: false,
      },
      sendwa: {
        data: {},
        visible: false
      },
      qrcode: {
        data: {},
        visible: false
      },
    };
  }

  componentDidMount() {
    _scrollFloatBtn()
  }

  fetchTable = (isNew = false) => {
    const { table } = this.state
    const params = getParamTable("default", table)
    this.fetch(params, isNew);
  }

  fetch = async (params = {}, isNew = false) => {
    this.setState({
      table: {
        ...params,
        loading_first: isMobile ? (isNew ? true : false) : false,
        loading: true
      }
    });

    params = {
      ...params,
      pagination: {
        ...params.pagination,
        current: isMobile ? (isNew ? 1 : params.pagination.current) : params.pagination.current
      }
    }
    _setAxios("alumni/table", "POST", params).then(resp => {
      if (resp.status === true) {
        let data = isNew ? [] : this.state.table.data

        let current = params.pagination.current
        this.setState({
          table: {
            ...params,
            loading_first: false,
            loading: false,
            data: isMobile ? [...data, ...resp.data.list] : resp.data.list,
            pagination: {
              ...params.pagination,
              current: isMobile ? current + 1 : current,
              total: resp.data.info.total
            }
          }
        });
      } else {
        this.setState({
          table: {
            ...params,
            loading_first: false,
            loading: false,
          }
        })
      }
    })
  };

  handleChangeSetValue = (name, value) => {
    const { values } = this.state;
    this.setForm(values, name, value)
  };

  setForm = (values, name, value) => {
    values[name] = value;

    this.setState({
      values: values,
    });
  }

  setTempTableFilter = (name, value) => {

    let values = this.state.filter.values
    values[name] = value

    this.setState({
      filter: {
        ...this.state.filter,
        values: values
      }
    })

  };

  setTableFilterFromTemp = () => {
    const params = getParamTempTableFiltering(this.state.table, this.state.filter.values)
    this.fetch(params, isMobile ? true : false)
    this.modalFilter(false)
  };
  // FILTER END ------------------------------------------

  modalFilter = (visible = false) => {
    this.setState({
      filter: {
        ...this.state.filter,
        visible: visible,
        values: {
          tahun_lulus: null,
          kategori: null,
        }
      },
    })
  }

  modalExport = (visible = false) => {
    this.setState({
      export: {
        ...this.state.export,
        visible: visible
      },
    })
  }
  modalVerification = (visible = false, data = {}) => {
    this.setState({
      verification: {
        data: data,
        visible: visible
      },
    })
  }
  modalPreviewKTA = (visible = false, data = {}) => {
    this.setState({
      previewKTA: {
        data: data,
        visible: visible
      },
    })
  }

  modalSendWa = (visible = false, data = {}) => {
    this.setState({
      sendwa: {
        data: data,
        visible: visible
      },
    })
  }

  modalQrCode = (visible = false, data = {}) => {
    this.setState({
      qrcode: {
        data: data,
        visible: visible
      },
    })
  }


  render() {

    const access = this.props.privilege.access["/peserta-didik/alumni"]
    if (!isAuth(this.props.privilege) || access === undefined) {
      return <AuthRedirect />
    }
    const action = access.action
    const { table } = this.state;

    const sortComponent = <>
      <Radio.Group onChange={(e) => {
        const params = getParamTable("sort_field", table, e.target.value)
        this.fetch(params, isMobile ? true : false)
      }} value={table.sorting.length > 0 ? table.sorting[0].field : ""} name="sort_field">
        <Space direction="vertical">
          {tableOptions.fields.map((row, i) => <Radio key={i} value={row.value}>{row.label}</Radio>)}
        </Space>
      </Radio.Group>
      <Divider orientation="left"></Divider>
      <Radio.Group onChange={(e) => {
        const params = getParamTable("sort", table, e.target.value)
        this.fetch(params, isMobile ? true : false)
      }} value={table.sorting.length > 0 ? table.sorting[0].sort : ""} name="sort_value">
        <Space direction="vertical">
          {tableOptions.sorts.map((row, i) => <Radio key={i} value={row.value}>{row.label}</Radio>)}
        </Space>
      </Radio.Group>
    </>

    return (
      <>
        <PageHeader
          style={{
            padding: 0
          }}
          onBack={() => window.history.back()}
          subTitle={<Breadcrumb style={{ margin: '16px 0' }} separator={<DoubleRightOutlined />}>
            <Breadcrumb.Item>Peserta Didik</Breadcrumb.Item>
            <Breadcrumb.Item>Alumni </Breadcrumb.Item>
          </Breadcrumb>}
          extra={[
            action.export ? <Button onClick={this.modalExport.bind(this, true)}><DownloadOutlined /> Export</Button> : null,
            // action.create ? <Link to={`/peserta-didik/aktif/create`}><Button type='primary'><PlusOutlined /> Tambah</Button></Link> : null
          ]}
        />
        <div className="site-layout-background" style={{ padding: 24, minHeight: 360 }}>
          <PageHeader
            className="site-page-header"
            title="Alumni"
            subTitle="Data alumni"
          />
          <MobileView>
            <div className='float-btn-center' id='float-btn-center' align='center'>
              <div className="float-btn-div">
                <Popover placement="top" content={sortComponent} trigger="click">
                  <Button type='primary' className='float-btn' icon={<SortAscendingOutlined />}>Urutkan</Button>
                </Popover>
                <Divider type="vertical" className="divider-border-white" />
                <Button type='primary' className='float-btn' icon={<FilterOutlined />} onClick={this.modalFilter.bind(this, true)}>Filter</Button>
              </div>

            </div>
          </MobileView>

          <Row gutter={[16, 16]}>
            <Col xs={24} sm={18} md={19} >
              <Input
                name="search"
                className='search-table'
                placeholder="Search..."
                prefix={<SearchOutlined className="site-form-item-icon" />}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    const params = getParamTable("search", table, e.target.value)
                    this.fetch(params, isMobile ? true : false)
                  }
                }}
                suffix={
                  <Tooltip title="Cari berdasarkan nama">
                    <InfoCircleOutlined style={{ color: 'rgba(0,0,0,.45)' }} />
                  </Tooltip>
                }
              />
            </Col>
            <Col xs={24} sm={6} md={5}>
              <BrowserView>
                <Button.Group className='ant-btn-group-fullwidth'>
                  <Button className='btn-border-radius-left' onClick={this.modalFilter.bind(this, true)}><FilterOutlined /></Button>
                  <Popover placement="bottom" content={sortComponent} trigger="click">
                    <Button block className='btn-border-radius-right'><SortAscendingOutlined /> Sort</Button>
                  </Popover>
                </Button.Group>
              </BrowserView>
            </Col>

            <Col xs={24}>
              <BrowserView>
                <Desktop
                  access={access}
                  state={this.state}
                  fetch={this.fetch}
                  fetchTable={this.fetchTable}
                  modalVerification={this.modalVerification}
                  modalPreviewKTA={this.modalPreviewKTA}
                  modalSendWa={this.modalSendWa}
                  modalQrCode={this.modalQrCode}
                />
              </BrowserView>
              <MobileView>
                <Mobile
                  access={access}
                  state={this.state}
                  fetch={this.fetch}
                  fetchTable={this.fetchTable}
                  modalVerification={this.modalVerification}
                  modalPreviewKTA={this.modalPreviewKTA}
                  modalSendWa={this.modalSendWa}
                  modalQrCode={this.modalQrCode}
                />
              </MobileView>
            </Col>

          </Row>
        </div>

        {
          this.state.filter.visible ?
            <Filter
              visible={this.state.filter.visible}
              hideModal={this.modalFilter.bind(this, false)}
              setTempTableFilter={this.setTempTableFilter}
              setTableFilterFromTemp={this.setTableFilterFromTemp}
            /> : ""
        }
        {
          this.state.export.visible ?
            <Export
              visible={this.state.export.visible}
              hideModal={this.modalExport.bind(this, false)}
            /> : ""
        }
        {
          this.state.verification.visible ?
            <Verification
              data={this.state.verification.data}
              visible={this.state.verification.visible}
              hideModal={this.modalVerification.bind(this, false, {})}
              fetchTable={this.fetchTable}
            /> : ""
        }
        {
          this.state.previewKTA.visible ?
            <PreviewKTA
              data={this.state.previewKTA.data}
              visible={this.state.previewKTA.visible}
              hideModal={this.modalPreviewKTA.bind(this, false)}
            /> : ""}
        {
          this.state.sendwa.visible ?
            <SendWA
              data={this.state.sendwa.data}
              visible={this.state.sendwa.visible}
              hideModal={this.modalSendWa.bind(this, false, {})}
              fetchTable={this.fetchTable}
            /> : ""
        }
        {
          this.state.qrcode.visible ?
            <GenerateQrCode
              data={this.state.qrcode.data}
              visible={this.state.qrcode.visible}
              hideModal={this.modalQrCode.bind(this, false, {})}
              fetchTable={this.fetchTable}
            /> : ""
        }
        <BackTop />
      </>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    privilege: state.privilege,
  }
}

export default connect(mapStateToProps)(SiswaIndex);
